<template>
  <div>
    <v-form ref="form" @submit.prevent="" lazy>
      <v-flex v-if="!dOpenCompDescargas">
        <v-layout row wrap justify-end>
          <v-flex xs12 text-xs-right>
            <v-btn @click="fEmitVolver()" class="datSecondaryBtn" small flat tile>Atrás</v-btn>
          </v-flex>
          <v-flex xs12 text-xs-right v-if="cRoleUser === 'ADMIN' || cRoleUser === 'REPRESENTANTE'">
            <v-btn class="datSecondaryBtn" small flat tile @click="dActiveFiltro = !dActiveFiltro">
              <span v-show="dScreenWidth > 500 ? true : false">{{ $t('buscadorAvanzado') }}</span>
              <v-icon small :right="dScreenWidth > 500 ? true : false"
                v-if="dActiveFiltro === false">mdi-filter-plus</v-icon>
              <v-icon small :right="dScreenWidth > 500 ? true : false" v-else>mdi-filter-minus</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-dialog v-if="!dOpenCompDescargas" v-model="dLoading" hide-overlay persistent width="300">
          <v-card class="datModalTitleContainer" dark>
            <v-card-text>
              {{ $t('cargandoContenido') }}
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-if="!dOpenCompDescargas" v-model="dLoagingExcel" hide-overlay persistent width="450">
          <v-card class="datModalTitleContainer" dark>
            <v-card-text>
              {{ $t('descargandoExcel') }}
              <br />
              {{ $t('descargandoContenido') }}
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-layout>
          <div class="subheading font-weight-bold mt-2 mb-2 px-3">{{ pFiltro.description }}</div>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 ml-3 mr-3>
            <v-layout
              v-if="cRoleUser === 'ADMIN' || cRoleUser === 'CLIENTE' || cRoleUser === 'SUCURSAL' || cRoleUser === 'MULTISUCURSAL' || cRoleUser === 'REPRESENTANTE'"
              row wrap>
              <v-flex md12 px-2>
                <label>{{ $t("aplicarFiltrosYcomenzar") }}</label>
              </v-flex>
              <v-flex md3 px-2>
                <v-menu :ref="dDatosFiltros.fechaIniMenu" lazy v-model="dDatosFiltros.fechaIniMenu"
                  transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                  :close-on-content-click="false">
                  <v-text-field required clearable color="data-colorcorp1" slot="activator" :label="$t('fechaInicial')"
                    v-model="dDatosFiltros.fechaIniString" append-icon="event" readonly
                    @click:clear="fGetFecha(null, 'ini')"></v-text-field>
                  <v-date-picker required :min="dDatosFiltros.fechaMinIni" clearable v-model="dDatosFiltros.fechaIni"
                    no-title scrollable :first-day-of-week="1" locale="es-es"
                    @input="fGetFecha(dDatosFiltros.fechaIni, 'ini')"></v-date-picker>
                </v-menu>
                <v-menu :ref="dDatosFiltros.fechaFinMenu" lazy v-model="dDatosFiltros.fechaFinMenu"
                  transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                  :close-on-content-click="false">
                  <v-text-field required clearable color="data-colorcorp1" slot="activator" :label="$t('fechaFinal')"
                    v-model="dDatosFiltros.fechaFinString" append-icon="event" readonly
                    @click:clear="fGetFecha(null, 'fin')"></v-text-field>
                  <v-date-picker required :min="dDatosFiltros.fechaMinFin" clearable v-model="dDatosFiltros.fechaFin"
                    no-title scrollable :first-day-of-week="1" locale="es-es"
                    @input="fGetFecha(dDatosFiltros.fechaFin, 'fin')"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md3 px-2>
                <v-text-field v-model="dDatosFiltros.numAlbaran" :label="$t('numAlbaran')"></v-text-field>
                <v-text-field v-model="dDatosFiltros.numDI" :label="$t('numDI')"></v-text-field>
              </v-flex>
              <v-flex v-if="cRoleUser === 'ADMIN'" md3 px-2>
                <v-select :items="dEstados" v-model="dEstadoSeleccionado" @change="fSelectEstado($event)"
                  :label="$t('estado')" item-value="id" item-text="nombre"></v-select>
              </v-flex>
            </v-layout>
            <v-layout v-if="(cRoleUser === 'ADMIN' || cRoleUser === 'REPRESENTANTE') && dActiveFiltro" row wrap>

              <v-flex md12 px-2>
                <label>{{ $t("advancedFilters") }}</label>
              </v-flex>
              <v-flex xs12 sm6 md4 px-2 v-if="dRole !== 'CLIENTE' && dRole !== 'SUCURSAL' && dRole !== 'MULTISUCURSAL'">
                <p class="datLabelGroup pt-0">
                  {{ $t('cliente') }}
                </p>
                <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient"></DatTextFieldCode>
                <DatTextFieldCode v-if="dRole !== 'SUCURSAL' && !dIsOnPremise" ref="TablaDeSucursal"
                  :pDataPass="dDataSucursal" @select="fSelectSucursal" @clean="fClearSucursal"></DatTextFieldCode>
              </v-flex>
              <v-flex></v-flex>
              <v-flex md3 my-10 px-2>
                <p class="datLabelGroup pt-0">
                  {{ $t('otrosFiltros') }}
                </p>
                <v-select class="m" clearable :items="dSelectCentros" item-value="id" item-text="nombre"
                  v-model="dDatosFiltros.centroTrabajo" :label="$t('centroTrabajo')"></v-select>
                <v-layout>
                  <v-text-field v-model="dDatosFiltros.codLER" :label="$t('codLER')"></v-text-field>
                  <v-select class="px-5" clearable :items="dFiltroFacturado" item-value="value" item-text="name"
                    v-model="dDatosFiltros.facturadoSN" :label="$t('facturacion')"></v-select>
                </v-layout>
              </v-flex>
              <v-flex md3 my-10 px-2>
              </v-flex>
            </v-layout>
            <!-- CAMPOS DE CLIENTE Y SUCURSAL -->
            <v-layout v-else>
              <template v-if="dRole !== 'SUCURSAL'">
                <v-flex v-if="dRole !== 'CLIENTE' && dRole !== 'MULTISUCURSAL'" md5 px-2>
                  <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @select="fSelectClient"
                    @clean="fClearCliente" @alert="fAlert"></DatTextFieldCode>
                </v-flex>
                <v-flex md5 px-2>
                  <DatTextFieldCode v-if="!dIsOnPremise" ref="TablaDeSucursal" :pDataPass="dDataSucursal"
                    @select="fSelectSucursal" @clean="fClearSucursal" @alert="fAlert"></DatTextFieldCode>
                </v-flex>
              </template>
            </v-layout>
            <v-flex xs12 text-xs-right>
              <v-tooltip top>
                <v-btn slot="activator" @click="fDescargarXlsx" icon>
                  <v-icon color="datSecondary">mdi-file-excel</v-icon>
                </v-btn>
                <span>{{ $t('descagarExcel') }}</span>
              </v-tooltip>
              <v-btn @click="fGetPedidos()" class="datSecondaryBtn" small flat tile>{{ $t('buscar') }}</v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <!-- {{ expanded }} -->
            <v-data-table item-key="key" :headers="dHeadersTabla" show-expand :items="dDatosTabla" :loading="dLoading"
              :no-results-text="$t('noResultados')" :no-data-text="$t('noResultados')" :expanded="expanded"
              :rows-per-page-text="dTextNumPag" v-bind:pagination.sync="dPaginationPED" :total-items="dTotalItems"
              class="tablePedidos" :rows-per-page-items="dRowsPerPageItemsPED">
              <template slot="headers" slot-scope="props">
                <tr class="lightPrimaryColorBackground">
                  <th class="text-xs-center" v-for="header in props.headers" :key="header.text" :id="header.value"
                    :class="['column sortable', dPaginationPED.descending ? 'desc' : 'asc', header.value === dPaginationPED.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']"
                    @click="fCambiaOrden(header.value)">
                    <v-icon v-if="header.sortable">arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <!-- CABECERA DEL ALBARÁN -->
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-center pr-0 pl-2" @click="fGetDetPedido(props)">
                    <v-icon :class="props.expanded ? 'iconRotate' : ''" class="cursorPointer">
                      arrow_downward
                    </v-icon>
                  </td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.Cliente }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.Sucursal }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.Nombre }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.Albaran }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.nameAlmacen }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.poblAlmacen }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.FechaAlbaran }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.CodigoLer }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.CodTratamiento }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.familiaProv }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.descFamiliaProv }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.idServicioWeb }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.Estado }}</span></td>
                  <td class="text-xs-center ellipsis"><span>{{ props.item.TipoRegistro }}</span></td>
                  <td class="text-xs-center ellipsis">
                    <v-btn flat icon small color="datPrimary" @click="fShowDescargas(props)">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <v-btn v-if="dCanValidate === true" flat icon small :color="fGetColor(props.item.validadoSN)"
                      @click="fShowValidator(props)">
                      <v-icon v-if="props.item.validadoSN === 'S'">mdi-check</v-icon>
                      <v-icon v-else-if="props.item.validadoSN === 'N'">mdi-cancel</v-icon>
                      <v-icon v-else>mdi-exclamation</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <!-- LINEAS DEL ALBARÁN -->
              <template slot="expand" slot-scope="props">
                <thead class="lighterPrimaryColorBackground">
                  <tr class="px-2">
                    <th v-for="item in dHeadersSubTabla" :key="item.value" :id="item.value" :width="item.width"
                      :class="item.class">{{ item.text }}</th>
                  </tr>
                </thead>
                <tr v-for="(linea, index) in dSubDatosTabla" :key="index" :class="props.expanded ? 'selectedRow' : ''">
                  <td class="text-xs-center" style="vertical-align: middle"><span>{{ linea.codServicio }}</span></td>
                  <td class="text-xs-center" style="vertical-align: middle"><span>{{ linea.nomServicio }}</span></td>
                  <td class="text-xs-center" style="vertical-align: middle"><span>{{ linea.articulo }}</span></td>
                  <td class="text-xs-center" style="vertical-align: middle"><span>{{ linea.denominacion }}</span></td>
                  <td class="text-xs-center" style="vertical-align: middle"><span>{{ linea.cantidad }}</span></td>
                  <td class="text-xs-center" style="vertical-align: middle"><span>{{ linea.precio }}</span></td>
                  <td class="text-xs-center" style="vertical-align: middle"><span>{{ linea.importe }}</span></td>
                  <td class="text-xs-center" style="vertical-align: middle"><span>{{ linea.di }}</span></td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>

      <ShpFiltroRecEntrDescargas v-else-if="dOpenCompDescargas" :pPedidoSeleccionado="dPedidoSeleccionado"
        :pUrlsInformes="dUrlInformes" @cerrar="fOcultarDescargas"></ShpFiltroRecEntrDescargas>
    </v-form>
    <v-dialog v-model="dOpenCompValidator" max-width="500px">
      <v-card>
        <ShpValidateService :pPedidoSeleccionado="dPedidoSeleccionado" :pUrlsInformes="dUrlInformes"
          @cerrar="fHideValidator" @reload="fGetPedidos"></ShpValidateService>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { generarPdf, abrirPestanaEnBlanco, abrirPdfEnPestanaPreabierta } from '@/utils/utilDescargarPdf'

import ShpFiltroEstadoRecogidas from '@/components/Informes/EstadoRecogidas/ShpFiltroEstadoRecogidas'
import ServiceRecogidasEntregas from '@/services/srv-recogidas-entregas'
import ShpFiltroRecEntrDescargas from '@/components/Informes/EstadoRecogidas/ShpFiltroRecEntrDescargas'
import ShpValidateService from '@/components/Informes/EstadoRecogidas/ShpValidateService'
import ServiceUser from '@/services/srv-users'
import SrvImpresion from '@/services/srv-impresion'
import SrvGeneral from '@/services/srv-general'


import * as XLSX from 'xlsx';

import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'

export default {
  extends: ShpFiltroEstadoRecogidas,
  data() {
    return {
      expand: false,
      dLoagingExcel: false,
      dFormatDate: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dScreenWidth: screen.width,
      dUrlAlbaran: '',
      dDateNow: new Date(),
      dTira: null,
      dIdOrganizacion: null,
      dEmpresa: 0,
      dActiveFiltro: false,
      dRole: '',
      dDatosFiltros: {},
      dDatosPedidos: [],
      dEstadoSeleccionado: 'C',
      dEstados: [],
      dHeadersTabla: [],
      dHeadersSubTabla: [],
      dPruebaTabla: [],
      dPruebaSubTabla: [],
      dShowDescargas: false,
      dOpenCompDescargas: false,
      dOpenCompValidator: false,
      dPedidoSeleccionado: null,
      dLineasPedido: [],
      dTextNumPag: '',
      dLoading: false,
      expanded: false,
      dDatosTabla: [],
      dSubDatosTabla: [],
      dTotalItems: 0,
      dUrlInformes: {},
      dSelectCentros: [],
      dFiltroFacturado: [
        { value: '', name: 'Todos' },
        { value: 'S', name: 'Facturado' },
        { value: 'N', name: 'Pendiente' },
      ],
      dDatosClient: {},
      dDataSucursal: {},
      dSelectSucursal: { codigo: '', nombre: '' },
      dIsOnPremise: localStorage.getItem('isOnPremise') === 'yes',
      dClass: 'subHeaderTextInTable text-xs-center',
      // PARTE DEL BUSCADOR DE CLIENTES
      dSelectClientIni: { codigo: '', nombre: '' },
      dRequestClient: { empresa: this.$store.getters.getAutenticacion.empresa },
      dPaginationPED: { 'sortBy': 'Nombre', 'descending': false, 'rowsPerPage': 10, 'page': 1 },
      dRowsPerPageItemsPED: [5, 10, 25, 500],
      dRowsPerPage: 10,
      dFirstSortTable: 0,
      // Plural -> Tránsitos, Singular -> Compra o Venta
      dTiposGestion: {
        'RECOGIDA_TRANSITOS': 'Recogidas',
        'ENTREGA_TRANSITO': 'Entregas',
        'RECOGIDA_PESADA': 'Recogidas',
        'ENTREGA_PESADA': 'Entregas'
      },
      dFechasValidas: false,
      dExcelFilters: {},
      dCanValidate: false
    }
  },
  components: {
    ShpFiltroRecEntrDescargas,
    ShpValidateService,
    DatTextFieldCode
  },
  props: {
    pFiltro: {
      type: Object,
      required: true
    },
    pLimitDate: {
      type: Object,
      required: true
    },
    pInformeComponente: {
      type: Object,
      required: true
    }
  },
  created() {
    this.fIniciarVariables()
    this.fLimitFechas()
    this.dRole = this.pLimitDate.roleUser
  },
  methods: {
    fIniciarVariables() {
      this.dEstados = [
        { id: 'T', nombre: this.$t('todos') },
        { id: 'P', nombre: this.$t('inProcess') },
        { id: 'C', nombre: this.$t('cerrada') }
      ]

      this.dDatosFiltros = {
        numAlbaran: '', numDI: '', estado: 'T', fechaIni: null, fechaIniString: '',
        fechaIniMenu: null, fechaMinIni: '', fechaFin: null, fechaFinString: '',
        fechaFinMenu: null, fechaMinFin: '', idCliente: '', centroTrabajo: '',
        codLER: '', facturadoSN: ''
      }

      const defaultClient = this.dSelectClientIni

      this.dDataClient = {
        errorMessages: [], label: 'clienteInicial', rowsPerPage: this.dRowsPerPage,
        headers: [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        urlWS: 'lovClte', item: { codigo: '', nombre: '' },
        filters: { codigo: 'cliente', nombre: 'nombre' },
        resultName: 'dataRes', request: this.dRequestClient,
        default: defaultClient, disabled: false, required: false,
        orderByDefault: 'cliente', orderDefault: 'ASC',
        isVisibleLoad: true, textCodigo: 'codigo', title: 'seleccionaUnCliente'
      }

      const defaultSucursal = this.dSelectSucursal
      this.dDataSucursal = {
        errorMessages: [], label: this.$t('sucursal'), rowsPerPage: 10,
        headers: [
          { text: this.$t('sucursal'), align: 'left', value: 'codigo', column: 'sucursal' },
          { text: this.$t('nombreSucursal'), align: 'left', value: 'nombre', column: 'razonSocial' }
        ],
        urlWS: 'lovDic', item: { codigo: '', nombre: '' },
        filters: { codigo: 'sucursal', nombre: 'razonSocial' },
        resultName: 'dataRes', request: null, default: defaultSucursal,
        disabled: false, required: true, orderByDefault: 'sucursal',
        orderDefault: 'sucursal', isVisibleLoad: true, textCodigo: 'codigo',
        title: this.$t('seleccionaUnaSucursal'), client: defaultClient.codigo
      }

      if (["CLIENTE", "MULTISUCURSAL"].includes(this.pLimitDate.roleUser)) {
        this.dDataSucursal.disabled = false
        this.dDataSucursal.request = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: this.$store.getters.getAutenticacion.cliente
        }
      }

      this.dDatosTabla = []
      this.dSubDatosTabla = []

      const commonHeaders = [
        { text: '', align: 'left', value: '', sortable: false, class: 'px-0', width: '10px', fixed: true },
        { text: this.$t('cliente'), align: 'left', value: 'Cliente' },
        { text: this.$t('sucursal'), align: 'left', value: 'Sucursal' },
        { text: this.$t('nombre'), align: 'left', value: 'Nombre' },
        { text: this.$t('numeroAlbaranCorto'), align: 'left', value: 'Albaran' },
      ];

      const commonHeaders2 = [
        { text: this.$t('fechaAlbaran'), align: 'left', value: 'FechaAlbaran' },
        { text: this.$t('codigoLER'), align: 'left', value: 'codLer' },
        { text: this.$t('tratamiento'), align: 'left', value: 'codTratamiento' },
        { text: this.$t('familiaProv'), align: 'left', value: 'familiaProv' },
        { text: this.$t('descFamiliaProv'), align: 'left', value: 'descFamiliaProv' },
        { text: this.$t('idServicioWeb'), align: 'left', value: 'idServicioWeb' },
        { text: this.$t('estado'), align: 'left', value: 'Estado' },
        { text: this.$t('tipoPedido'), align: 'left', value: 'TipoRegistro' },
        { text: this.$t('descargas'), align: 'left', value: 'descargar' }
      ];

      const tablas = {
        R: { text: 'numRecogidas', headers: [...commonHeaders, { text: this.$t('almacen'), align: 'left', value: 'nameAlmacen' }, { text: this.$t('poblacionAlm'), align: 'left', value: 'poblAlmacen' }, ...commonHeaders2] },
        E: { text: 'numEntradas', headers: [...commonHeaders, { text: this.$t('almacen'), align: 'left', value: 'nameAlmacen' }, { text: this.$t('poblacionAlm'), align: 'left', value: 'poblAlmacen' }, ...commonHeaders2] },
        P: { text: 'numPedidos', headers: [...commonHeaders, { text: this.$t('almacen'), align: 'left', value: 'nameAlmacen' }, { text: this.$t('poblacionAlm'), align: 'left', value: 'poblAlmacen' }, ...commonHeaders2] },
        T: { text: 'numRecogidasEntradas', headers: [...commonHeaders, { text: this.$t('almacen'), align: 'left', value: 'nameAlmacen' }, { text: this.$t('poblacionAlm'), align: 'left', value: 'poblAlmacen' }, ...commonHeaders2] }
      }


      this.dHeadersSubTabla = [
        'codServicio', 'nomServicio', 'articulo', 'denominacion', 'cantidad', 'precio', 'importe', 'di'
      ].map(key => ({ text: this.$t(key), align: 'left', value: key, sortable: true, class: this.dClass, width: '500px' }))

      this.fGetPermisosResiduos()

      const baseExcel = (cols) => ({
        columns: cols.map(field => ({ label: '', field })),
        data: [],
        fileName: 'recogidasEntregas',
        fileType: 'xlsx',
        sheetName: ''
      })

      const extraCols = this.dCanValidate ? ['validado', 'usuarioValidacion', 'fechaValidacion'] : []

      const excelBaseCols = {
        base: ['Cliente', 'Sucursal', 'Nombre', 'Albaran', 'FechaAlbaran', 'CodigoLer', 'CodTratamiento', 'Estado', 'TipoRegistro', 'Ejercicio', 'Articulo', 'Denominacion', 'Cantidad', 'Precio', 'Importe', 'Nº DI', 'Familia', 'familiaProv', 'descFamiliaProv', 'idServicioWeb'],
        comprasExtra: ['nameAlmacen', 'cifDescarga', 'dirDescarga', 'cpDescarga', 'almProvincia', 'nima', 'numInscripcion', 'tipoInscripcion', 'poblAlmacen', 'transportista', 'codPeligrosidad'],
        ventasExtra: ['cifDescarga', 'dirDescarga', 'cpDescarga', 'almProvincia', 'nima', 'numInscripcion', 'tipoInscripcion', 'transportista', 'codPeligrosidad']
      }
      // 
      // Con los 3 puntos lo que estamos haciendo es combinar los arrays.
      // Ejemplo:
      // const a = [1, 2]
      // const b = [3, 4]
      // const combinado = [...a, ...b] 
      // Resultado de combinado => [1, 2, 3, 4]
      // 
      this.dExcelFilters = baseExcel([
        ...excelBaseCols.base,
        ...(this.pFiltro.filtro === 'R' ? excelBaseCols.comprasExtra : []),
        ...(this.pFiltro.filtro === 'E' ? excelBaseCols.ventasExtra : []),
        ...extraCols
      ])

      const tipo = tablas[this.pFiltro.filtro]
      if (tipo) {
        this.dTextNumPag = this.$t(tipo.text)
        this.dHeadersTabla = tipo.headers
      }

      const auth = this.$store.getters.getAutenticacion
      this.dTira = auth.tira
      this.dIdOrganizacion = auth.organizacion
      this.dEmpresa = auth.empresa

      this.fGetCentrosTrabajos()
    },
    fEmitVolver() {
      this.$emit('cerrar')
    },
    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClientIni.codigo = item.codigo
        this.dSelectClientIni.nombre = item.nombre
        this.dDatosFiltros.idCliente = item.codigo
      }
      else {
        this.dSelectClientIni.codigo = ''
        this.dSelectClientIni.nombre = ''
        this.dDatosFiltros.idCliente = ''
      }

      this.dDataSucursal.client = item.codigo
      this.dDataSucursal.request = {
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: item.codigo
      }
      if (item.codigo !== '' && item.codigo !== undefined && this.$refs.TablaDeSucursal !== undefined) {
        this.$refs.TablaDeSucursal.fChangeDisabled(false)
      }
      this.fClearSucursal();
    },
    fSelectSucursal(item) {
      this.dSelectSucursal.codigo = item.codigo;
      this.dSelectSucursal.nombre = item.nombre;
      this.dDataSucursal.default.codigo = item.codigo;
      this.dDataSucursal.default.nombre = item.nombre;
    },
    fClearCliente() {
    },
    fClearSucursal() {
      if (!this.fSelectSucursal.client && !this.dDatosFiltros.idCliente) {
        this.dDataSucursal.disabled = true;
        this.$refs.TablaDeSucursal.fChangeDisabled(true)
      }
      this.dSelectSucursal = {}
      this.$refs.TablaDeSucursal.fActualizarItem(this.dSelectSucursal);
    },
    fGetFecha(val, tipo) {
      switch (tipo) {
        case 'ini':
          if (val) {
            this.dDatosFiltros.fechaIniString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
          }
          else {
            this.dDatosFiltros.fechaIniString = null;
            this.dDatosFiltros.fechaIni = null;
          }
          this.dDatosFiltros.fechaIniMenu = false;
          break;
        // 
        case 'fin':
          if (val) {
            this.dDatosFiltros.fechaFinString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
          }
          else {
            this.dDatosFiltros.fechaFinString = null;
            this.dDatosFiltros.fechaFin = null;
          }
          this.dDatosFiltros.fechaFinMenu = false;
      }
    },
    fGetCentrosTrabajos() {
      this.dLoading = true;
      const payload = {
        empresa: this.dEmpresa,
        comprobarPrivSn: 'S'
      }
      SrvGeneral.lovCentro(payload).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const datos = response.data.dataRes
          if (Array.isArray(datos)) {
            datos.forEach(item => {
              this.dSelectCentros.push({ id: item.centro, nombre: item.centro + ' - ' + item.denominacion })
            })
          } else {
            this.$emit('alert', '<b>' + this.$t('notFoundDefault') + '</b><br>' + this.$t('notCentrosFoundDesc'))
          }
        }
        this.dLoading = false
      })
    },
    fGetPermisosResiduos() {
      ServiceUser.getPermisosResiduos(this.$store.getters.getAutenticacion.usuario).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const permisos = response.data.dataRes
          this.dCanValidate = permisos.some(per => per.permiso === "RES_022")
        }
      })
    },
    fGetPedidos() {
      this.dLoading = true
      this.dDatosTabla = []
      this.dDatosFiltros.estado = this.dEstadoSeleccionado

      const formatFecha = (fecha) => this.fCheckValid(fecha)
        ? this.$moment(fecha, this.dFormatDate.years).format(this.dFormatDate.default)
        : ''

      this.dDatosFiltros.fechaIniClient = formatFecha(this.dDatosFiltros.fechaIniClient)
      this.dDatosFiltros.fechaFinClient = formatFecha(this.dDatosFiltros.fechaFinClient)

      if (this.dSelectSucursal) {
        this.dDatosFiltros.sucursal = this.dSelectSucursal.codigo
      }
      if (this.dRole === 'SUCURSAL') {
        this.dDatosFiltros.sucursal = this.$store.getters.getAutenticacion.sucursal
      }

      if (!this.fCheckFiltrosPendientes()) {
        this.dLoading = false
        this.$emit('alert', `<b>${this.$t('avisoFactura')}</b><br>${this.$t('avisoFacturaDesc')}`)
        return
      }

      const payload = {
        centroTrabajo: this.dDatosFiltros.centroTrabajo,
        fechaInicial: this.dDatosFiltros.fechaIniString,
        estado: this.dDatosFiltros.estado,
        clienteInicial: this.dDatosFiltros.idCliente,
        clienteFinal: this.dDatosFiltros.idCliente,
        sucursal: this.dDatosFiltros.sucursal,
        tipoGestion: this.pFiltro.filtro,
        fechaFinal: this.dDatosFiltros.fechaFinString,
        codLer: this.dDatosFiltros.codLER,
        tira: this.dTira,
        tipoEmpresa: '0',
        empresa: this.dEmpresa,
        numeroDI: this.dDatosFiltros.numDI,
        numeroAlbaran: this.dDatosFiltros.numAlbaran,
        facturadoSN: this.dDatosFiltros.facturadoSN,
        offset: this.dPaginationPED.rowsPerPage * (this.dPaginationPED.page - 1) + 1,
        numRows: this.dPaginationPED.rowsPerPage,
        orderBy: this.dPaginationPED.sortBy,
        descargaExcelSN: 'N',
        order: this.dPaginationPED.descending ? 'DESC' : 'ASC'
      }

      if (payload.fechaInicial && payload.fechaFinal) {
        payload.numeroAnyosAntiguedadPedidos = '0'
      }

      ServiceRecogidasEntregas.getRecogidas(payload).then(response => {
        this.dDatosTabla = []
        if (!this.fRespuestaCorrecta(response)) {
          this.dLoading = false
          this.$emit('alert', response.data.errorMsg.message || `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
          return
        }

        const datos = response.data.dataRes
        this.dExcelFilters.data = []

        if (Array.isArray(datos)) {
          datos.forEach(item => {
            const albaran = item.Albaran !== undefined ? item.Albaran : item.Pedido
            const codTrat = (item.tipoTratamiento != null) ? item.tipoTratamiento + '' + item.codTratamiento : ''
            const fechaAlbaran = this.$moment(item.FechaAlbaran, this.dFormatDate.years).format(this.dFormatDate.default)
            const tipoRegistro = this.dTiposGestion[item.TipoRegistro]

            const baseData = {
              Cliente: item.Cliente,
              Sucursal: item.codSucursal,
              Nombre: item.Nombre,
              Albaran: albaran,
              nameAlmacen: item.nameAlmacen,
              poblAlmacen: item.poblAlmacen,
              FechaAlbaran: fechaAlbaran,
              CodigoLer: item.codLer,
              CodTratamiento: codTrat,
              Estado: item.Estado,
              TipoRegistro: tipoRegistro,
              Ejercicio: item.Ejercicio,
              familiaProv: item.familiaProv || '',
              descFamiliaProv: item.descFamiliaProv || '',
              idServicioWeb: item.idServicioWeb || ''
            }

            this.dDatosTabla.push({
              ...baseData,
              rn: item.rn,
              codSucursal: item.Sucursal,
              descargar: this.$t('descargar'),
              tipoGestion: item.TipoGestion,
              validadoSN: item.validado,
              usuarioValidacion: item.usuarioValidacion,
              fechaValidacion: item.fechaValidacion,
              observaciones: item.observaciones,
              key: albaran + item.codLer
            })

            this.dExcelFilters.data.push(baseData)
          })
          this.dTotalItems = response.data.numReg
        }
        this.dLoading = false
      }).catch(error => {
        this.dLoading = false
        this.$emit('alert', error || `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
      })
    },
    fDescargarXlsx() {
      this.dLoagingExcel = true;
      this.dDatosFiltros.estado = this.dEstadoSeleccionado;
      this.dDatosFiltros.fechaIniClient = this.fCheckValid(this.dDatosFiltros.fechaIniCliente) ? this.$moment(this.dDatosFiltros.fechaIniClient, this.dFormatDate.years).format(this.dFormatDate.default) : '';
      this.dDatosFiltros.fechaFinClient = this.fCheckValid(this.dDatosFiltros.fechaFinClient) ? this.$moment(this.dDatosFiltros.fechaFinClient, this.dFormatDate.years).format(this.dFormatDate.default) : '';

      if (this.dRole === 'SUCURSAL') {
        this.dDatosFiltros.sucursal = this.$store.getters.getAutenticacion.sucursal;
      }

      const pag = this.dPaginationPED;
      const payload = {
        centroTrabajo: this.dDatosFiltros.centroTrabajo,
        fechaInicial: this.dDatosFiltros.fechaIniString,
        estado: this.dDatosFiltros.estado,
        clienteInicial: this.dDatosFiltros.idCliente,
        clienteFinal: this.dDatosFiltros.idCliente,
        sucursal: this.dDatosFiltros.sucursal,
        tipoGestion: this.pFiltro.filtro,
        fechaFinal: this.dDatosFiltros.fechaFinString,
        tira: this.dTira,
        tipoEmpresa: '0',
        empresa: this.dEmpresa,
        numeroDI: this.dDatosFiltros.numDI,
        numeroAlbaran: this.dDatosFiltros.numAlbaran,
        offset: pag.rowsPerPage * (pag.page - 1) + 1,
        numRows: this.dTotalItems,
        orderBy: pag.sortBy,
        descargaExcelSN: 'S',
        order: pag.descending ? 'DESC' : 'ASC'
      };

      if (this.dDatosFiltros.fechaIniString && this.dDatosFiltros.fechaFinString) {
        payload.numeroAnyosAntiguedadPedidos = '0';
      }

      ServiceRecogidasEntregas.getRecogidas(payload).then(response => {
        if (!this.fRespuestaCorrecta(response)) {
          throw new Error(response.data.errorMsg.message);
        }

        const datos = response.data.dataRes.result;
        const workbook = XLSX.utils.book_new();

        const allData = datos.map(item => {
          const codTrat = item.tipoTratamiento ? item.tipoTratamiento + '' + item.codTratamiento : '';
          return {
            'Cliente': item.Cliente,
            'Sucursal': item.codSucursal,
            'Nombre': item.Nombre,
            'Albaran': item.Albaran,
            'nameAlmacen': item.nameAlmacen,
            'cifDescarga': item.cifDescarga,
            'dirDescarga': item.dirDescarga,
            'cpDescarga': item.cpDescarga,
            'almProvincia': item.almProvincia,
            'nima': item.nima !== null && item.nima !== undefined ? item.nima : '',
            'numInscripcion': item.numInscripcion,
            'tipoInscripcion': item.tipoInscripcion,
            'poblAlmacen': item.poblAlmacen,
            'FechaAlbaran': item.FechaAlbaran,
            'transportista': item.transportista || '',
            'codPeligrosidad': item.codPeligrosidad || '',
            'CodigoLer': item.codLer,
            'CodTratamiento': codTrat,
            'Estado': item.Estado,
            'TipoRegistro': this.dTiposGestion[item.TipoRegistro] || '',
            'Ejercicio': item.Ejercicio,
            ...(this.pFiltro.filtro === 'P' ? { 'sRef': item.refPedido } : {}),
            'codServicio': item.codServicio !== null && item.codServicio !== undefined ? item.codServicio : '',
            'nomServicio': item.nomServicio !== null && item.nomServicio !== undefined ? item.nomServicio : '',
            'Articulo': item.Articulo !== null && item.Articulo !== undefined ? item.Articulo : '',
            'Denominacion': item.DescArticulo !== null && item.DescArticulo !== undefined ? item.DescArticulo : '',
            'Cantidad': item.Cantidad !== null && item.Cantidad !== undefined ? item.Cantidad : '',
            'Precio': item.Precio !== null && item.Precio !== undefined ? item.Precio : '',
            'Importe': item.Importe !== null && item.Importe !== undefined ? item.Importe : '',
            'Nº DI': item.NumeroDI !== null && item.NumeroDI !== undefined ? item.NumeroDI : '',
            'Familia': item.FamArt !== null && item.FamArt !== undefined ? item.FamArt : '',
            'familiaProv': item.familiaProv !== null && item.familiaProv !== undefined ? item.familiaProv : '',
            'descFamiliaProv': item.descFamiliaProv !== null && item.descFamiliaProv !== undefined ? item.descFamiliaProv : '',
            'idServicioWeb': item.idServicioWeb !== null && item.idServicioWeb !== undefined ? item.idServicioWeb : ''
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(allData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'RecogidasEntregas');
        XLSX.writeFile(workbook, 'recogidasEntregas.xlsx');
        this.dLoagingExcel = false;
      }).catch(error => {
        this.dLoagingExcel = false;
        this.$emit('alert', error || this.$t('errorDefault') + '</b><br>' + this.$t('errorDefaultDesc'));
      });
    },
    fSacarLinea(item, datos) {
      return this.fGetDetPedidoPromise(item, datos)
    },
    fGetDetPedidoPromise(itemPasado, datos) {
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        tipoEmpresa: '0',
        numeroAlbaran: itemPasado.Albaran,
        ejercicio: itemPasado.Ejercicio,
        tipoGestion: itemPasado.TipoGestion,
        codigoLER: itemPasado.codLer
      }

      if (itemPasado.TipoGestion === 'P') {
        payload.numeroPedido = itemPasado.Albaran
        payload.cliente = itemPasado.Cliente
      }

      const orEmpty = value => (value !== null && value !== undefined ? value : '')

      return ServiceRecogidasEntregas.getDetPedido(payload)
        .then(response => {
          if (!(response.status === 200 && Array.isArray(response.data.dataRes.result))) {
            return datos
          }

          const items = response.data.dataRes.result
          const codTrat = itemPasado.tipoTratamiento != null
            ? itemPasado.tipoTratamiento + '' + itemPasado.codTratamiento
            : ''

          items.forEach(item => {
            const dataItem = {
              'Cliente': itemPasado.Cliente,
              'Sucursal': itemPasado.codSucursal,
              'Nombre': itemPasado.Nombre,
              'Albaran': itemPasado.Albaran,
              'nameAlmacen': itemPasado.nameAlmacen,
              'cifDescarga': itemPasado.cifDescarga,
              'dirDescarga': itemPasado.dirDescarga,
              'cpDescarga': itemPasado.cpDescarga,
              'almProvincia': itemPasado.almProvincia,
              'nima': orEmpty(itemPasado.nima),
              'numInscripcion': itemPasado.numInscripcion,
              'tipoInscripcion': itemPasado.tipoInscripcion,
              'poblAlmacen': itemPasado.poblAlmacen,
              'FechaAlbaran': this.$moment(itemPasado.FechaAlbaran, this.dFormatDate.years).format(this.dFormatDate.default),
              'transportista': itemPasado.transportista,
              'codPeligrosidad': itemPasado.codPeligrosidad,
              'CodigoLer': itemPasado.codLer,
              'CodTratamiento': codTrat,
              'Estado': itemPasado.Estado,
              'TipoRegistro': this.dTiposGestion[itemPasado.TipoRegistro],
              'Ejercicio': itemPasado.Ejercicio,
              'Articulo': orEmpty(item.Articulo),
              'Denominacion': orEmpty(item.DescArticulo),
              'Cantidad': orEmpty(item.Cantidad),
              'Precio': (item.Precio !== null && item.Precio !== '') ? item.Precio : '',
              'Importe': (item.Importe !== null && item.Importe !== '') ? item.Importe : '',
              'Nº DI': orEmpty(item.NumeroDI),
              'Familia': orEmpty(item.FamArt),
              'familiaProv': orEmpty(item.familiaProv),
              'descFamiliaProv': orEmpty(item.descFamiliaProv),
              'idServicioWeb': orEmpty(item.idServicioWeb)
            }

            if (this.dCanValidate) {
              dataItem.validado = itemPasado.validado
              dataItem.usuarioValidacion = itemPasado.usuarioValidacion
              dataItem.fechaValidacion = itemPasado.fechaValidacion
            }

            datos.data.push(dataItem)
          })

          return datos
        })
        .catch(error => {
          console.log(error)
          return Promise.reject(error)
        })
    },
    fCabeceraTituloPedido(datos, item) {
      datos.data.push({ //Setea las cabeceras del excel
        'Cliente': 'Cliente',
        'Sucursal': 'Sucursal',
        'Nombre': 'Nombre',
        'Albaran': 'Albaran',
        'nameAlmacen': 'Almacen',
        'cifDescarga': 'CIF descarga',
        'dirDescarga': 'Dirección descarga',
        'cpDescarga': 'CP descarga',
        'almProvincia': 'Provincia descarga',
        'nima': 'NIMA',
        'numInscripcion': 'Nº inscripción almacén descarga',
        'tipoInscripcion': 'Tipo inscripción almacén descarga',
        'poblAlmacen': 'Poblacion Alm.',
        'FechaAlbaran': 'Fecha Albaran',
        'transportista': 'Transportista',
        'codPeligrosidad': 'Código Peligrosidad',
        'CodigoLer': 'Cod. LER',
        'CodTratamiento': 'Cod. Tratamiento',
        'Estado': 'Estado',
        'TipoRegistro': 'Tipo Registro',
        'Ejercicio': 'Ejercicio',
        'Articulo': 'Articulo',
        'Denominacion': 'Denominacion',
        'Cantidad': 'Cantidad',
        'Precio': 'Precio',
        'Importe': 'Importe',
        'Nº DI': 'Nº DI',
        'Familia': 'Familia',
        'familiaProv': 'Familia Proveedor',
        'descFamiliaProv': 'Descripción Familia Proveedor',
        'idServicioWeb': 'ID Servicio PDA',
        'validado': 'Validado S/N',
        'usuarioValidacion': 'Usuario Validación',
        'fechaValidacion': 'Fecha Validación'
      })
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    fCabeceraVacia(datos, veces) {
      for (let i = 0; i < veces; i++) {
        datos.data.push({
          'Cliente': '',
          'Sucursal': '',
          'Nombre': '',
          'Albaran': '',
          'nameAlmacen': '',
          'poblAlmacen': '',
          'FechaAlbaran': '',
          'Estado': '',
          'TipoRegistro': '',
          'Ejercicio': '',
          'familiaProv': '',
          'descFamiliaProv': '',
          'idServicioWeb': ''
        })
      }
    },
    fGetDetPedido(props) {
      let datos = null
      this.dSubDatosTabla = []
      props.expanded = !props.expanded

      if (props.expanded) {
        this.dLoading = true;

        const payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          tipoEmpresa: '0',
          numeroAlbaran: props.item.Albaran,
          ejercicio: props.item.Ejercicio,
          tipoGestion: props.item.tipoGestion,
          codigoLER: props.item.CodigoLer
        }
        if (props.item.tipoGestion === 'P') {
          payload.numeroPedido = props.item.Albaran;
          payload.cliente = props.item.Cliente;
        }
        ServiceRecogidasEntregas.getDetPedido(payload).then(response => {
          if (this.fRespuestaCorrecta(response)) {
            datos = response.data.dataRes.result
            datos.forEach(item => {
              this.fAddSubDatos(item)
            })
          }
          this.dLoading = false
        })
      }
    },
    fAddSubDatos(item) {
      this.dSubDatosTabla.push({
        'codServicio': (item.codServicio !== null) ? item.codServicio : '',
        'nomServicio': (item.nomServicio !== null) ? item.nomServicio : '',
        'articulo': (item.Articulo !== null) ? item.Articulo : '',
        'denominacion': (item.DescArticulo !== null) ? item.DescArticulo : '',
        'cantidad': (item.Cantidad !== null) ? item.Cantidad : '',
        'precio': (item.Precio !== null && item.Precio !== '') ? item.Precio : '',
        'importe': (item.Importe !== null && item.Importe !== '') ? item.Importe : '',
        'di': (item.NumeroDI !== null) ? item.NumeroDI : '',
        'numAlbaran': (item.Identificador !== null) ? item.Identificador : '',
        'descargar': this.$t('descargar')
      })
    },
    fShowDescargas(props) {
      this.dLoading = true
      if (props.item.tipoGestion !== 'P') {
        const payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          tipoEmpresa: '0',
          numeroAlbaran: props.item.Albaran,
          ejercicio: props.item.Ejercicio,
          tipoGestion: props.item.tipoGestion,
          codigoLER: props.item.CodigoLer
        }

        ServiceRecogidasEntregas.getDetPedido(payload).then(response => {
          if (this.fRespuestaCorrecta(response)) {
            const datos = response.data.dataRes.result
            this.dUrlInformes = datos
            // 
            this.dOpenCompDescargas = true
            this.dPedidoSeleccionado = props
            this.dLoading = false;
          }
          else {
            throw new Error(response.data.errorMsg.message);
          }
        }).catch(error => {
          this.dLoading = false;
          this.$emit('alert', error || this.$t('errorDefault') + '</b><br>' + this.$t('errorDefaultDesc'))
        })
      } else {
        const ventanaPdf = abrirPestanaEnBlanco()
        // 
        const payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          tipoEmpresa: '0',
          numeroAlbaran: props.item.Albaran,
          ejercicio: props.item.Ejercicio,
          tipoGestion: props.item.tipoGestion,
          codigoLER: props.item.CodigoLer,
          numeroPedido: props.item.Albaran,
          cliente: props.item.Cliente
        }
        // 
        ServiceRecogidasEntregas.getDetPedido(payload).then(response => {
          if (this.fRespuestaCorrecta(response)) {
            const datos = response.data.dataRes.result
            let albaranesEncontrados = 0
            datos.forEach(dato => {
              if (dato.Identificador > 0) {
                albaranesEncontrados++;
              }
            })
            if (albaranesEncontrados > 0) {
              const payload = {
                tira: this.$store.getters.getAutenticacion.tira,
                empresa: this.$store.getters.getAutenticacion.empresa,
                tipoEmpresa: '0',
                pdfSn: 'S',
                ejercicio: props.item.Ejercicio,
                albaranInicial: datos[0].Identificador,
                albaranFinal: datos[0].Identificador
              }
              SrvImpresion.getReportAlbaran(payload).then(response => {
                if (response.data.infoMsg.code === '0' || response.data.dataRes.errorCode !== -21001) {
                  abrirPdfEnPestanaPreabierta(generarPdf(response.data.dataRes.report), ventanaPdf)
                  this.dLoading = false
                } else {
                  if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
                  this.dLoading = false
                  this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + response.data.dataRes.errorMsg + '  (' + response.data.dataRes.errorCode + ' ) ')
                }
              })
            } else {
              if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
              this.dLoading = false
              console.log(error)
              this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br>' + this.$t('errorDefaultDesc'))
            }
          }
          else {
            throw new Error(response.data.errorMsg.message);
          }
        }).catch(error => {
          if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
          this.dLoading = false
          console.log(error)
          this.$emit('alert', '<b>' + this.$t('notAlbaranFound') + '</b><br>' + this.$t('notAlbaranFoundInPedDesc'))
        })
      }
    },
    fOcultarDescargas() {
      this.dOpenCompDescargas = false;
      this.dPedidoSeleccionado = null;
    },
    fShowValidator(props) {
      this.dOpenCompValidator = true;
      this.dPedidoSeleccionado = props;
    },
    fHideValidator() {
      this.dOpenCompValidator = false;
    },
    fLimitFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dDatosFiltros.fechaIni = this.pLimitDate.fechaIniLimit
        this.dDatosFiltros.fechaMinIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.years)
        this.dDatosFiltros.fechaIniString = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.default)
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dDatosFiltros.fechaFin = this.pLimitDate.fechaFinLimit
        this.dDatosFiltros.fechaMinFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.years)
        this.dDatosFiltros.fechaFinString = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    },
    fSelectEstado(event) {
      this.dEstadoSeleccionado = (this.fCheckValid(event)) ? event : 'T'
    },
    // ORDENACION
    fCambiaOrden(column) {
      this.dPaginationPED.page = 1
      this.dPaginationPED.rowsPerPage = this.dRowsPerPage
      if (this.dPaginationPED.sortBy === column) {
        this.dPaginationPED.descending = !this.dPaginationPED.descending
      } else {
        this.dPaginationPED.sortBy = column
        this.dPaginationPED.descending = false
      }
    },
    // VALIDACIONES
    fCheckValid(value) {
      let finalValue = false;
      if (value !== undefined && value !== '' && value !== null) {
        finalValue = true
      }
      return finalValue
    },
    fRespuestaCorrecta(response) {
      let finalValue = false;
      if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
        finalValue = true
      }
      return finalValue
    },
    fCheckFiltrosPendientes() {
      let returnValue = false;
      if (this.dRole === 'CLIENTE') {
        this.dDatosFiltros.idCliente = this.$store.getters.getAutenticacion.cliente
        returnValue = true
      } else if (this.dRole === 'SUCURSAL') {
        this.dDatosFiltros.idCliente = this.$store.getters.getAutenticacion.cliente
        this.dSelectSucursal.codigo = this.$store.getters.getAutenticacion.sucursal
        returnValue = true
      } else {
        if (this.fNotEmpty(this.dDatosFiltros.idCliente) || this.fNotEmpty(this.dDatosFiltros.fechaIni) || this.fNotEmpty(this.dDatosFiltros.fechaFin)) {
          returnValue = true
        }
      }
      return returnValue;
    },
    fNotEmpty(value) {
      let returnValue = false;
      if (value !== undefined && value !== null && value !== '' && value) {
        returnValue = true;
      }
      return returnValue;
    },
    fGetColor(validado) {
      let returnValue = 'datPrimary'
      if (validado === 'S') {
        returnValue = 'green'
      } else if (validado === 'N') {
        returnValue = 'red'
      }
      return returnValue;
    },
  },
  watch: {
    dPaginationPED: {
      handler(newPage, oldPage) {
        if (this.dFirstSortTable > 0) {
          this.fGetPedidos()
        }
        this.dFirstSortTable++
      },
      deep: true
    }
  },
  computed: {
    cRoleUser() {
      return this.dRole
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Informes/EstadoRecogidas/ShpFiltroRecogidasEntradas.vue